import { render, staticRenderFns } from "./UserGroupSection.vue?vue&type=template&id=ce1d019c&scoped=true&"
import script from "./UserGroupSection.vue?vue&type=script&lang=js&"
export * from "./UserGroupSection.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupSection.vue?vue&type=style&index=0&id=ce1d019c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1d019c",
  null
  
)

export default component.exports